import SvgIcon from '@material-ui/core/SvgIcon';
import React from 'react';

export default function ScheduleIcon({ ...props }) {
  return (
    <SvgIcon width="52" height="52" viewBox="0 0 52 52" {...props}>
      <path
        d="M26 52C40.3594 52 52 40.3594 52 26C52 11.6406 40.3594 0 26 0C11.6406 0 0 11.6406 0 26C0 40.3594 11.6406 52 26 52Z"
        fill="#EDECEB"
      />
      <path
        d="M45.5 49.3568H6.49998C4.33331 49.3568 2.59998 47.6234 2.59998 45.4568V9.57676C2.59998 7.41009 4.33331 5.67676 6.49998 5.67676H45.5C47.6666 5.67676 49.4 7.41009 49.4 9.57676V45.4568C49.4 47.6234 47.6666 49.3568 45.5 49.3568Z"
        fill="white"
      />
      <path
        d="M2.59998 18.5468V9.57676C2.59998 7.41009 4.33331 5.67676 6.49998 5.67676H45.3266C47.5366 5.67676 49.3133 7.54009 49.2266 9.75009L49.01 18.5468H2.59998Z"
        fill="#F37865"
      />
      <path
        d="M49.01 19.8466H2.60005C1.86338 19.8466 1.30005 19.2833 1.30005 18.5466C1.30005 17.8099 1.86338 17.2466 2.60005 17.2466H49.01C49.7467 17.2466 50.31 17.8099 50.31 18.5466C50.31 19.2833 49.7467 19.8466 49.01 19.8466Z"
        fill="#454B54"
      />
      <path
        d="M12.35 32.8036C15.0544 32.8036 17.2467 30.6113 17.2467 27.9069C17.2467 25.2026 15.0544 23.0103 12.35 23.0103C9.64568 23.0103 7.45337 25.2026 7.45337 27.9069C7.45337 30.6113 9.64568 32.8036 12.35 32.8036Z"
        fill="#EAD777"
      />
      <path
        d="M25.9999 32.8036C28.7043 32.8036 30.8966 30.6113 30.8966 27.9069C30.8966 25.2026 28.7043 23.0103 25.9999 23.0103C23.2956 23.0103 21.1033 25.2026 21.1033 27.9069C21.1033 30.6113 23.2956 32.8036 25.9999 32.8036Z"
        fill="#E1E5E3"
      />
      <path
        d="M39.65 32.8036C42.3543 32.8036 44.5466 30.6113 44.5466 27.9069C44.5466 25.2026 42.3543 23.0103 39.65 23.0103C36.9456 23.0103 34.7533 25.2026 34.7533 27.9069C34.7533 30.6113 36.9456 32.8036 39.65 32.8036Z"
        fill="#E1E5E3"
      />
      <path
        d="M25.9999 45.6737C28.7043 45.6737 30.8966 43.4814 30.8966 40.777C30.8966 38.0727 28.7043 35.8804 25.9999 35.8804C23.2956 35.8804 21.1033 38.0727 21.1033 40.777C21.1033 43.4814 23.2956 45.6737 25.9999 45.6737Z"
        fill="#E1E5E3"
      />
      <path
        d="M39.65 45.6732C42.3543 45.6732 44.5466 43.4809 44.5466 40.7765C44.5466 38.0722 42.3543 35.8799 39.65 35.8799C36.9456 35.8799 34.7533 38.0722 34.7533 40.7765C34.7533 43.4809 36.9456 45.6732 39.65 45.6732Z"
        fill="#F37865"
      />
      <path
        d="M12.35 45.6732C15.0544 45.6732 17.2467 43.4809 17.2467 40.7765C17.2467 38.0722 15.0544 35.8799 12.35 35.8799C9.64568 35.8799 7.45337 38.0722 7.45337 40.7765C7.45337 43.4809 9.64568 45.6732 12.35 45.6732Z"
        fill="#E1E5E3"
      />
      <path
        d="M45.5 50.657H6.50005C3.64005 50.657 1.30005 48.317 1.30005 45.457V9.57695C1.30005 6.71695 3.64005 4.37695 6.50005 4.37695H45.5C48.3601 4.37695 50.7001 6.71695 50.7001 9.57695V45.457C50.7001 48.317 48.3601 50.657 45.5 50.657ZM6.50005 6.97695C5.07005 6.97695 3.90005 8.14695 3.90005 9.57695V45.457C3.90005 46.887 5.07005 48.057 6.50005 48.057H45.5C46.93 48.057 48.1 46.887 48.1 45.457V9.57695C48.1 8.14695 46.93 6.97695 45.5 6.97695H6.50005Z"
        fill="#454B54"
      />
      <path
        d="M14.3 10.7901C13.5633 10.7901 13 10.2268 13 9.49014V1.69014C13 0.95347 13.5633 0.390137 14.3 0.390137C15.0367 0.390137 15.6 0.95347 15.6 1.69014V9.49014C15.6 10.1835 15.0367 10.7901 14.3 10.7901Z"
        fill="#454B54"
      />
      <path
        d="M37.7 10.7901C36.9634 10.7901 36.4 10.2268 36.4 9.49014V1.69014C36.4 0.95347 36.9634 0.390137 37.7 0.390137C38.4367 0.390137 39 0.95347 39 1.69014V9.49014C39 10.1835 38.4367 10.7901 37.7 10.7901Z"
        fill="#454B54"
      />
    </SvgIcon>
  );
}
